import _slicedToArray from "C:\\Users\\conta\\PhpstormProjects\\efficience-vitale-reader\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "C:\\Users\\conta\\PhpstormProjects\\efficience-vitale-reader\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _objectSpread from "C:\\Users\\conta\\PhpstormProjects\\efficience-vitale-reader\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
var _marked = /*#__PURE__*/_regeneratorRuntime().mark(processQueuedAction),
  _marked2 = /*#__PURE__*/_regeneratorRuntime().mark(sendJsonCommand);
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import { buffers, eventChannel } from 'redux-saga';
import { actionChannel, call, delay, put, race, select, take, takeEvery } from 'redux-saga/effects';
import { restFormatResponse } from '../actions/config/restCommandParams';
import { dmpCommandFailure, dmpCommandFailureContextualized, dmpCommandStartContextualized, dmpCommandStopped, dmpCommandSuccess, dmpCommandSuccessContextualized, dmpCommandTooLong, dmpRemoteCommandFailure, dmpRemoteCommandFailureContextualized, dmpRemoteCommandStart, dmpRemoteCommandSuccess, dmpRemoteCommandSuccessContextualized, dmpSynchronousCommandFailure, dmpSynchronousCommandSuccess } from '../actions/dmpconnectActions';
import { dmpconnectActionConstants } from '../constants';
import { createError, errorTypes, softwareErrors } from '../errors';
import { getDmpConnectJSHost, getDmpConnectJSPort, getDmpConnectJSProtocol } from '../helpers/accessors';
import CustomWebsocket from '../utils/customWebsocket';
import { registerDcParameters } from "./initializationSagas";

/**
 * Setup a new websocket to DMPConnectJS
 * @param hostname
 * @param port
 * @returns {CustomWebsocket}
 */
export var setupCustomSocket = function setupCustomSocket(hostname, port) {
  if (!Object.prototype.hasOwnProperty.call(window, 'WebSocket')) {
    // TODO manage error
  }
  return new CustomWebsocket("".concat(hostname, ":").concat(port));
};
export var setupSocket = function setupSocket(hostname, port) {
  if (!Object.prototype.hasOwnProperty.call(window, 'WebSocket')) {
    // TODO manage error
  }
  return new WebSocket("".concat(hostname, ":").concat(port));
};
var sockets = [];
var getSocket = function getSocket(groupName) {
  return sockets[groupName] || undefined;
};
var setSocket = function setSocket(socket, groupName) {
  sockets[groupName] = socket;
};

/**
 * Websocket channel
 * @param command
 * @param context
 * @param persistent
 * @returns {EventChannel<any>}
 */
export var websocketChannel = function websocketChannel(command) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var persistent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var _ref, _ref$section, section, groupName, existingSocket, dmpcjsProtocol, dmpcjsHost, dmpcjsPort, socket, channel;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _ref = context || {}, _ref$section = _ref.section, section = _ref$section === void 0 ? null : _ref$section;
          groupName = section || command.s_commandName; // close already running socket
          if (!persistent && command.multipleCalls === false) {
            existingSocket = getSocket(groupName);
            if (existingSocket !== undefined) {
              existingSocket.cancel();
            }
          }
          _context.next = 5;
          return select(getDmpConnectJSProtocol);
        case 5:
          dmpcjsProtocol = _context.sent;
          _context.next = 8;
          return select(getDmpConnectJSHost);
        case 8:
          dmpcjsHost = _context.sent;
          _context.next = 11;
          return select(getDmpConnectJSPort);
        case 11:
          dmpcjsPort = _context.sent;
          socket = setupCustomSocket("".concat(dmpcjsProtocol, "://").concat(dmpcjsHost), dmpcjsPort);
          channel = eventChannel(function (emit) {
            socket.configEventHandlers(emit, command, persistent);
            return function () {
              socket.close();
            };
          });
          if (!persistent && command.multipleCalls === false) {
            setSocket(socket, groupName);
          }
          return _context.abrupt("return", channel);
        case 16:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })();
};
var checkType = function checkType(type, value) {
  switch (type) {
    case 'array':
      return Array.isArray(value);
    case 'string':
      return typeof value === 'string' || value instanceof String;
    case 'number':
      return typeof value === 'number' && Number.isFinite(value);
    case 'object':
      return value && typeof value === 'object' && value.constructor === Object;
    default:
      return true;
  }
};
var checkExpectedResult = function checkExpectedResult(expected, result) {
  return expected.reduce(function (checks, _ref2) {
    var name = _ref2.name,
      type = _ref2.type;
    if (Object.prototype.hasOwnProperty.call(result, name)) {
      if (!checkType(type, result[name])) {
        checks[name] = "expected type ".concat(type); // eslint-disable-line no-param-reassign
      }
    } else {
      checks[name] = 'expected in the result'; // eslint-disable-line no-param-reassign
    }
    return checks;
  }, {});
};
var handleWSResponse = function handleWSResponse(message, action, synchronous) {
  var retries = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var command, context, silentError, expected, _context$remote, remote, _context$noRetries, noRetries, failureFunc, successFunc, sendFunc, failureContextualizedFunc, successContextualizedFunc, stop, returnError, error, forceSilent, checks;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          command = action.command, context = action.context, silentError = action.silentError, expected = action.expected;
          _context$remote = context.remote, remote = _context$remote === void 0 ? false : _context$remote, _context$noRetries = context.noRetries, noRetries = _context$noRetries === void 0 ? false : _context$noRetries;
          failureFunc = dmpCommandFailure;
          successFunc = dmpCommandSuccess;
          sendFunc = sendCommand;
          failureContextualizedFunc = dmpCommandFailureContextualized;
          successContextualizedFunc = dmpCommandSuccessContextualized;
          if (synchronous) {
            failureFunc = dmpSynchronousCommandFailure;
            successFunc = dmpSynchronousCommandSuccess;
            sendFunc = sendSynchronousCommand;
          } else if (remote) {
            failureFunc = dmpRemoteCommandFailure;
            successFunc = dmpRemoteCommandSuccess;
            failureContextualizedFunc = dmpRemoteCommandFailureContextualized;
            successContextualizedFunc = dmpRemoteCommandSuccessContextualized;
          }
          stop = true;
          returnError = false;
          forceSilent = false;
          if (!(message.s_status === 'error')) {
            _context2.next = 29;
            break;
          }
          returnError = true;
          forceSilent = true;
          if (!(retries >= 20 || noRetries === true)) {
            _context2.next = 19;
            break;
          }
          console.log('returnerror', retries);
          error = _objectSpread({
            i_apiErrorType: errorTypes.SoftwareErrors,
            i_apiErrorCode: softwareErrors.WEBSOCKET_ERROR
          }, message, {
            retries: retries
          });
          _context2.next = 27;
          break;
        case 19:
          console.log('ws error, retry', retries + 1);
          if (!(retries === 0)) {
            _context2.next = 23;
            break;
          }
          _context2.next = 23;
          return call(registerDcParameters);
        case 23:
          _context2.next = 25;
          return delay(1000);
        case 25:
          _context2.next = 27;
          return call(sendFunc, action, retries + 1);
        case 27:
          _context2.next = 36;
          break;
        case 29:
          if (!(message.s_status === 'too_long')) {
            _context2.next = 35;
            break;
          }
          _context2.next = 32;
          return put(dmpCommandTooLong(context, command));
        case 32:
          // yield put(dmpCommandTooLongContextualized(context, command));
          stop = false;
          _context2.next = 36;
          break;
        case 35:
          if (message.s_status !== 'OK') {
            returnError = true;
          } else if (expected !== undefined) {
            checks = checkExpectedResult(expected, message);
            if (Object.entries(checks).length > 0) {
              error = {
                i_apiErrorType: errorTypes.SoftwareErrors,
                i_apiErrorCode: softwareErrors.UNEXPECTED_ERROR,
                result: message,
                errors: checks
              };
              returnError = true;
            }
          }
        case 36:
          if (!stop) {
            _context2.next = 48;
            break;
          }
          if (!returnError) {
            _context2.next = 44;
            break;
          }
          _context2.next = 40;
          return put(failureFunc(error || message, context, command, forceSilent ? true : silentError));
        case 40:
          _context2.next = 42;
          return put(failureContextualizedFunc(error || message, context, command, forceSilent ? true : silentError));
        case 42:
          _context2.next = 48;
          break;
        case 44:
          _context2.next = 46;
          return put(successFunc(message, context, command));
        case 46:
          _context2.next = 48;
          return put(successContextualizedFunc(message, context, command));
        case 48:
          return _context2.abrupt("return", stop);
        case 49:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  })();
};
var sendSynchronousCommand = function sendSynchronousCommand(action) {
  var retries = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    var command, context, silentError, _context$noRetries2, noRetries, channel, _yield$take, message, stop, wsError;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          command = action.command, context = action.context, silentError = action.silentError;
          _context$noRetries2 = context.noRetries, noRetries = _context$noRetries2 === void 0 ? false : _context$noRetries2;
          _context3.prev = 2;
          _context3.next = 5;
          return call(websocketChannel, command, context);
        case 5:
          channel = _context3.sent;
          _context3.next = 8;
          return put(dmpCommandStartContextualized(context, command));
        case 8:
          if (!true) {
            _context3.next = 20;
            break;
          }
          _context3.next = 11;
          return take(channel);
        case 11:
          _yield$take = _context3.sent;
          message = _yield$take.message;
          _context3.next = 15;
          return call(handleWSResponse, message, action, true, retries);
        case 15:
          stop = _context3.sent;
          if (!stop) {
            _context3.next = 18;
            break;
          }
          return _context3.abrupt("break", 20);
        case 18:
          _context3.next = 8;
          break;
        case 20:
          _context3.next = 40;
          break;
        case 22:
          _context3.prev = 22;
          _context3.t0 = _context3["catch"](2);
          if (!(retries >= 20 || noRetries === true)) {
            _context3.next = 32;
            break;
          }
          wsError = {
            i_apiErrorType: errorTypes.SoftwareErrors,
            i_apiErrorCode: softwareErrors.WEBSOCKET_ERROR
          };
          _context3.next = 28;
          return put(dmpSynchronousCommandFailure(wsError, context, command, silentError));
        case 28:
          _context3.next = 30;
          return put(dmpCommandFailureContextualized(wsError, context, command, silentError));
        case 30:
          _context3.next = 40;
          break;
        case 32:
          console.log('ws error catched, retry');
          if (!(retries === 0)) {
            _context3.next = 36;
            break;
          }
          _context3.next = 36;
          return call(registerDcParameters);
        case 36:
          _context3.next = 38;
          return delay(1000);
        case 38:
          _context3.next = 40;
          return call(sendSynchronousCommand, action, retries + 1);
        case 40:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[2, 22]]);
  })();
};

/**
 * Send asynchronous command to DMPConnectJS
 * @param action
 * @returns {IterableIterator<CallEffect|TakeEffect|PutEffect<{data, context, type, command}>>}
 */
var sendCommand = function sendCommand(action) {
  var retries = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    var command, context, silentError, expected, _context$remote2, remote, channel, _yield$take2, message, stop, wsError;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          command = action.command, context = action.context, silentError = action.silentError, expected = action.expected;
          _context$remote2 = context.remote, remote = _context$remote2 === void 0 ? false : _context$remote2;
          _context4.prev = 2;
          _context4.next = 5;
          return call(websocketChannel, command, context);
        case 5:
          channel = _context4.sent;
          if (!remote) {
            _context4.next = 11;
            break;
          }
          _context4.next = 9;
          return put(dmpRemoteCommandStart(context, command));
        case 9:
          _context4.next = 13;
          break;
        case 11:
          _context4.next = 13;
          return put(dmpCommandStartContextualized(context, command));
        case 13:
          if (!true) {
            _context4.next = 25;
            break;
          }
          _context4.next = 16;
          return take(channel);
        case 16:
          _yield$take2 = _context4.sent;
          message = _yield$take2.message;
          _context4.next = 20;
          return call(handleWSResponse, message, action, false, retries);
        case 20:
          stop = _context4.sent;
          if (!stop) {
            _context4.next = 23;
            break;
          }
          return _context4.abrupt("break", 25);
        case 23:
          _context4.next = 13;
          break;
        case 25:
          _context4.next = 45;
          break;
        case 27:
          _context4.prev = 27;
          _context4.t0 = _context4["catch"](2);
          if (!(retries >= 20)) {
            _context4.next = 37;
            break;
          }
          wsError = {
            i_apiErrorType: errorTypes.SoftwareErrors,
            i_apiErrorCode: softwareErrors.WEBSOCKET_ERROR
          };
          _context4.next = 33;
          return put(dmpCommandFailure(wsError, context, command, silentError));
        case 33:
          _context4.next = 35;
          return put(dmpCommandFailureContextualized(wsError, context, command, silentError));
        case 35:
          _context4.next = 45;
          break;
        case 37:
          console.log('ws error catched, retry', _context4.t0);
          if (!(retries === 0)) {
            _context4.next = 41;
            break;
          }
          _context4.next = 41;
          return call(registerDcParameters);
        case 41:
          _context4.next = 43;
          return delay(1000);
        case 43:
          _context4.next = 45;
          return call(sendCommand, action, retries + 1);
        case 45:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[2, 27]]);
  })();
};
export var handleAsynchronousCommand = /*#__PURE__*/_regeneratorRuntime().mark(function handleAsynchronousCommand() {
  return _regeneratorRuntime().wrap(function handleAsynchronousCommand$(_context5) {
    while (1) switch (_context5.prev = _context5.next) {
      case 0:
        _context5.next = 2;
        return takeEvery(dmpconnectActionConstants.DMPC_SEND_COMMAND, sendCommand);
      case 2:
      case "end":
        return _context5.stop();
    }
  }, handleAsynchronousCommand);
});
export var handleCancelCommand = /*#__PURE__*/_regeneratorRuntime().mark(function handleCancelCommand(action) {
  var section, existingSocket;
  return _regeneratorRuntime().wrap(function handleCancelCommand$(_context6) {
    while (1) switch (_context6.prev = _context6.next) {
      case 0:
        section = action.context.section;
        _context6.next = 3;
        return select(getSocket, section);
      case 3:
        existingSocket = _context6.sent;
        existingSocket.cancel();
        _context6.next = 7;
        return put(dmpCommandStopped(action.context));
      case 7:
      case "end":
        return _context6.stop();
    }
  }, handleCancelCommand);
});
var prioBuffer = function prioBuffer() {
  var highPrioBuffer = buffers.expanding(5);
  var loPrioBuffer = buffers.expanding(5);
  var put = function put(action) {
    var _action$context$prior = action.context.priority,
      priority = _action$context$prior === void 0 ? false : _action$context$prior;
    if (priority) {
      highPrioBuffer.put(action);
    } else {
      loPrioBuffer.put(action);
    }
  };
  var take = function take() {
    if (!highPrioBuffer.isEmpty()) {
      return highPrioBuffer.take();
    }
    if (!loPrioBuffer.isEmpty()) {
      return loPrioBuffer.take();
    }
  };
  var flush = function flush() {
    var items = highPrioBuffer.flush();
    items.concat(loPrioBuffer.flush());
    return items;
  };
  var isEmpty = function isEmpty() {
    return highPrioBuffer.isEmpty() && loPrioBuffer.isEmpty();
  };
  return {
    put: put,
    take: take,
    flush: flush,
    isEmpty: isEmpty
  };
};
function processQueuedAction(action) {
  var _action, _action$command, mssGetUpToDatePscToken, s_login, command, mssPscToken, _s_login$split, _s_login$split2, login;
  return _regeneratorRuntime().wrap(function processQueuedAction$(_context7) {
    while (1) switch (_context7.prev = _context7.next) {
      case 0:
        _action = action, _action$command = _action.command, mssGetUpToDatePscToken = _action$command.mssGetUpToDatePscToken, s_login = _action$command.s_login, command = _objectWithoutProperties(_action$command, ["mssGetUpToDatePscToken", "s_login"]);
        if (!(mssGetUpToDatePscToken === true)) {
          _context7.next = 7;
          break;
        }
        _context7.next = 4;
        return select(function (_ref3) {
          var mssPscAccessToken = _ref3.dmpconnectMSSConfiguration.mssPscAccessToken;
          return mssPscAccessToken;
        });
      case 4:
        mssPscToken = _context7.sent;
        _s_login$split = s_login.split(':::'), _s_login$split2 = _slicedToArray(_s_login$split, 1), login = _s_login$split2[0];
        action = _objectSpread({}, action, {
          command: _objectSpread({}, command, {
            s_login: "".concat(login, ":::").concat(mssPscToken)
          })
        });
      case 7:
        return _context7.abrupt("return", action);
      case 8:
      case "end":
        return _context7.stop();
    }
  }, _marked);
}
export var handleSynchronousCommand = /*#__PURE__*/_regeneratorRuntime().mark(function handleSynchronousCommand() {
  var requestChannel, action;
  return _regeneratorRuntime().wrap(function handleSynchronousCommand$(_context8) {
    while (1) switch (_context8.prev = _context8.next) {
      case 0:
        _context8.next = 2;
        return actionChannel(dmpconnectActionConstants.DMPC_SEND_SYNCHRONOUS_COMMAND, prioBuffer());
      case 2:
        requestChannel = _context8.sent;
      case 3:
        if (!true) {
          _context8.next = 14;
          break;
        }
        _context8.next = 6;
        return take(requestChannel);
      case 6:
        action = _context8.sent;
        _context8.next = 9;
        return call(processQueuedAction, action);
      case 9:
        action = _context8.sent;
        _context8.next = 12;
        return call(sendSynchronousCommand, action);
      case 12:
        _context8.next = 3;
        break;
      case 14:
      case "end":
        return _context8.stop();
    }
  }, handleSynchronousCommand);
});
function sendHttpRequest(_ref4) {
  var type = _ref4.type,
    url = _ref4.url,
    endpoint = _ref4.endpoint,
    command = _ref4.command,
    context = _ref4.context,
    silentError = _ref4.silentError,
    jwt = _ref4.jwt;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
    var message, _context$remote3, remote, _yield$race, response, timeout, error, data, responseFormatter, _error, _error2, _error3, _error4;
    return _regeneratorRuntime().wrap(function _callee5$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          message = {};
          _context$remote3 = context.remote, remote = _context$remote3 === void 0 ? false : _context$remote3;
          _context9.prev = 2;
          if (!remote) {
            _context9.next = 8;
            break;
          }
          _context9.next = 6;
          return put(dmpRemoteCommandStart(context, command));
        case 6:
          _context9.next = 10;
          break;
        case 8:
          _context9.next = 10;
          return put(dmpCommandStartContextualized(context, command));
        case 10:
          _context9.next = 12;
          return race({
            response: call(fetch, "".concat(url).concat(endpoint), {
              method: 'post',
              body: JSON.stringify(command),
              headers: jwt ? {
                'Authorization': "Bearer ".concat(jwt)
              } : {}
            }),
            timeout: delay((command.i_timeout || 30) * 1000)
          });
        case 12:
          _yield$race = _context9.sent;
          response = _yield$race.response;
          timeout = _yield$race.timeout;
          if (!timeout) {
            _context9.next = 20;
            break;
          }
          error = createError(errorTypes.SoftwareErrors, softwareErrors.WEBSOCKET_TIMEOUT);
          message = _objectSpread({}, error, {
            s_status: 'KO'
          });
          _context9.next = 29;
          break;
        case 20:
          if (!(response.status > 0)) {
            _context9.next = 28;
            break;
          }
          _context9.next = 23;
          return call([response, response.json]);
        case 23:
          data = _context9.sent;
          message = data;
          if (type.indexOf('_REST_') !== -1 && message.s_status === 'OK') {
            responseFormatter = restFormatResponse[context.section] && restFormatResponse[context.section].formatter;
            if (responseFormatter) {
              message = responseFormatter(data);
            }
          }
          _context9.next = 29;
          break;
        case 28:
          if (type.indexOf('_REST_') !== -1) {
            _error = createError(errorTypes.SoftwareErrors, softwareErrors.CONNECTOR_REST_UNREACHABLE);
            message = _objectSpread({}, command, _error, {
              s_status: 'KO'
            });
          } else {
            _error2 = createError(errorTypes.SoftwareErrors, softwareErrors.DMPCONNECTJS_MISSING_OR_UNREACHABLE);
            message = _objectSpread({}, _error2, {
              s_status: 'KO'
            });
          }
        case 29:
          if (!(message.s_status === 'OK')) {
            _context9.next = 43;
            break;
          }
          if (remote) {
            _context9.next = 37;
            break;
          }
          _context9.next = 33;
          return put(dmpCommandSuccess(message, context, command));
        case 33:
          _context9.next = 35;
          return put(dmpCommandSuccessContextualized(message, context, command));
        case 35:
          _context9.next = 41;
          break;
        case 37:
          _context9.next = 39;
          return put(dmpRemoteCommandSuccess(message, context, command));
        case 39:
          _context9.next = 41;
          return put(dmpRemoteCommandSuccessContextualized(message, context, command));
        case 41:
          _context9.next = 54;
          break;
        case 43:
          if (remote) {
            _context9.next = 50;
            break;
          }
          _context9.next = 46;
          return put(dmpCommandFailure(message, context, _objectSpread({}, command, {
            endpoint: endpoint
          }), silentError));
        case 46:
          _context9.next = 48;
          return put(dmpCommandFailureContextualized(message, context, _objectSpread({}, command, {
            endpoint: endpoint
          }), silentError));
        case 48:
          _context9.next = 54;
          break;
        case 50:
          _context9.next = 52;
          return put(dmpRemoteCommandFailure(message, context, _objectSpread({}, command, {
            endpoint: endpoint
          }), silentError));
        case 52:
          _context9.next = 54;
          return put(dmpRemoteCommandFailureContextualized(message, context, _objectSpread({}, command, {
            endpoint: endpoint
          }), silentError));
        case 54:
          _context9.next = 63;
          break;
        case 56:
          _context9.prev = 56;
          _context9.t0 = _context9["catch"](2);
          if (type.indexOf('_REST_') !== -1) {
            _error3 = createError(errorTypes.SoftwareErrors, softwareErrors.CONNECTOR_REST_UNREACHABLE);
            message = _objectSpread({}, command, _error3, {
              s_status: 'KO'
            });
          } else {
            _error4 = createError(errorTypes.SoftwareErrors, softwareErrors.DMPCONNECTJS_MISSING_OR_UNREACHABLE);
            message = _objectSpread({}, _error4, {
              s_status: 'KO'
            });
          }
          _context9.next = 61;
          return put(dmpCommandFailure(message, context, _objectSpread({}, command, {
            endpoint: endpoint
          }), silentError));
        case 61:
          _context9.next = 63;
          return put(dmpCommandFailureContextualized(message, context, _objectSpread({}, command, {
            endpoint: endpoint
          }), silentError));
        case 63:
        case "end":
          return _context9.stop();
      }
    }, _callee5, null, [[2, 56]]);
  })();
}
function sendJsonCommand(action, synchronous) {
  var command, context, silentError, expected, message, _yield$race2, response, timeout, error, _error5, successActionfunction, failureActionfunction;
  return _regeneratorRuntime().wrap(function sendJsonCommand$(_context10) {
    while (1) switch (_context10.prev = _context10.next) {
      case 0:
        command = action.command, context = action.context, silentError = action.silentError, expected = action.expected;
        _context10.next = 3;
        return put(dmpCommandStartContextualized(context, command));
      case 3:
        // window.dmpConnectJsonApi.sendJsonCommand( JSON.stringify(command), (command.i_timeout || 30) * 1000 ).then
        // ( (resData ) => {
        //     const jsonResult = JSON.parse(resData)
        //
        //     console.log("Synchronous answer received.");
        //     console.log("Answer:\n" + resData + "\n");
        // });
        message = {};
        _context10.next = 6;
        return race({
          response: call(window.dmpConnectJsonApi.sendJsonCommand, JSON.stringify(command), (command.i_timeout || 30) * 1000),
          timeout: delay((command.i_timeout || 30) * 1000)
        });
      case 6:
        _yield$race2 = _context10.sent;
        response = _yield$race2.response;
        timeout = _yield$race2.timeout;
        if (timeout) {
          error = createError(errorTypes.SoftwareErrors, softwareErrors.WEBSOCKET_TIMEOUT);
          message = _objectSpread({}, error, {
            s_status: 'KO'
          });
        } else {
          try {
            message = JSON.parse(response);
          } catch (e) {
            _error5 = createError(errorTypes.SoftwareErrors, softwareErrors.UNEXPECTED_ERROR);
            message = _objectSpread({}, _error5, {
              message: e.message,
              s_status: 'KO'
            });
          }
        }
        if (!(message.s_status === 'OK')) {
          _context10.next = 18;
          break;
        }
        if (synchronous) {
          successActionfunction = dmpSynchronousCommandSuccess;
        } else {
          successActionfunction = dmpCommandSuccess;
        }
        _context10.next = 14;
        return put(successActionfunction(message, context, command));
      case 14:
        _context10.next = 16;
        return put(dmpCommandSuccessContextualized(message, context, command));
      case 16:
        _context10.next = 23;
        break;
      case 18:
        if (synchronous) {
          failureActionfunction = dmpSynchronousCommandFailure;
        } else {
          failureActionfunction = dmpCommandFailure;
        }
        _context10.next = 21;
        return put(failureActionfunction(message, context, command, silentError));
      case 21:
        _context10.next = 23;
        return put(dmpCommandFailureContextualized(message, context, command, silentError));
      case 23:
      case "end":
        return _context10.stop();
    }
  }, _marked2);
}
export var handleHTTPCommand = /*#__PURE__*/_regeneratorRuntime().mark(function handleHTTPCommand() {
  return _regeneratorRuntime().wrap(function handleHTTPCommand$(_context11) {
    while (1) switch (_context11.prev = _context11.next) {
      case 0:
        _context11.next = 2;
        return takeEvery([dmpconnectActionConstants.DMPC_SEND_HTTP_COMMAND, dmpconnectActionConstants.DMPC_SEND_REST_COMMAND], sendHttpRequest);
      case 2:
      case "end":
        return _context11.stop();
    }
  }, handleHTTPCommand);
});
export var handleHTTPSynchronousCommand = /*#__PURE__*/_regeneratorRuntime().mark(function handleHTTPSynchronousCommand() {
  var requestChannel, action;
  return _regeneratorRuntime().wrap(function handleHTTPSynchronousCommand$(_context12) {
    while (1) switch (_context12.prev = _context12.next) {
      case 0:
        _context12.next = 2;
        return actionChannel([dmpconnectActionConstants.DMPC_SEND_HTTP_SYNCHRONOUS_COMMAND, dmpconnectActionConstants.DMPC_SEND_REST_SYNCHRONOUS_COMMAND], prioBuffer());
      case 2:
        requestChannel = _context12.sent;
      case 3:
        if (!true) {
          _context12.next = 14;
          break;
        }
        _context12.next = 6;
        return take(requestChannel);
      case 6:
        action = _context12.sent;
        _context12.next = 9;
        return call(processQueuedAction, action);
      case 9:
        action = _context12.sent;
        _context12.next = 12;
        return call(sendHttpRequest, action);
      case 12:
        _context12.next = 3;
        break;
      case 14:
      case "end":
        return _context12.stop();
    }
  }, handleHTTPSynchronousCommand);
});
export var handleJSONCommand = /*#__PURE__*/_regeneratorRuntime().mark(function handleJSONCommand() {
  return _regeneratorRuntime().wrap(function handleJSONCommand$(_context13) {
    while (1) switch (_context13.prev = _context13.next) {
      case 0:
        _context13.next = 2;
        return takeEvery([dmpconnectActionConstants.DMPC_SEND_JSON_COMMAND], sendJsonCommand);
      case 2:
      case "end":
        return _context13.stop();
    }
  }, handleJSONCommand);
});
export var handleJSONSynchronousCommand = /*#__PURE__*/_regeneratorRuntime().mark(function handleJSONSynchronousCommand() {
  var requestChannel, action;
  return _regeneratorRuntime().wrap(function handleJSONSynchronousCommand$(_context14) {
    while (1) switch (_context14.prev = _context14.next) {
      case 0:
        _context14.next = 2;
        return actionChannel(dmpconnectActionConstants.DMPC_SEND_JSON_SYNCHRONOUS_COMMAND);
      case 2:
        requestChannel = _context14.sent;
      case 3:
        if (!true) {
          _context14.next = 14;
          break;
        }
        _context14.next = 6;
        return take(requestChannel);
      case 6:
        action = _context14.sent;
        _context14.next = 9;
        return call(processQueuedAction, action);
      case 9:
        action = _context14.sent;
        _context14.next = 12;
        return call(sendJsonCommand, action, true);
      case 12:
        _context14.next = 3;
        break;
      case 14:
      case "end":
        return _context14.stop();
    }
  }, handleJSONSynchronousCommand);
});